import { render } from "./tab-treatments.vue?vue&type=template&id=6aada360&scoped=true"
import script from "./tab-treatments.vue?vue&type=script&lang=js"
export * from "./tab-treatments.vue?vue&type=script&lang=js"

import "./tab-treatments.vue?vue&type=style&index=0&id=6aada360&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aada360"]])

export default __exports__